<template>
    <div style="margin: 5px 0px 5px 10px;">
    
        <div v-if="loading" class="sk-cube-grid">
          <div class="sk-cube sk-cube1 loading-nav-waiter"></div>
          <div class="sk-cube sk-cube2 loading-nav-waiter"></div>
          <div class="sk-cube sk-cube3 loading-nav-waiter"></div>
          <div class="sk-cube sk-cube4 loading-nav-waiter"></div>
          <div class="sk-cube sk-cube5 loading-nav-waiter"></div>
          <div class="sk-cube sk-cube6 loading-nav-waiter"></div>
          <div class="sk-cube sk-cube7 loading-nav-waiter"></div>
          <div class="sk-cube sk-cube8 loading-nav-waiter"></div>
          <div class="sk-cube sk-cube9 loading-nav-waiter"></div>
        </div>
        
        <div v-else-if="tree && children.length > 0" id="scroll-uses" class="tree-container sidebar" 
            style="width: 100%; text-align: right; overflow-y: scroll; overflow-x: hidden;" 
            :style="{'max-height': mh ? mh + 'px' : 'unset'}">
                <use-list-item :key="index" v-for="(child, index) in children" :branch="child" :isFirstSon="true" :isLastSon="index == children.length -1" :isChild="isChild">
                </use-list-item>
        </div>
        
    </div>
</template>

<script>
import useListItem from "./use-list-item.vue";
import { eventBus } from "../../eventbus";
    export default {
        props: {
            activeData: {
                type: Object,
                default: null
            },
            mh: Number,
            isChild: Boolean
        },
        components: {
            useListItem
        },
        data: function(){
            return {
                activeOne: null,
                tree: null,
                children: [],
                loading: true
            }
        },
        mounted: function(){
            if(this.$root.richiestaImpiego != null){
                this.loadImpieghi(true);
            }else if(this.activeData != null){
                this.loadImpieghi();
            }
            try {  
                var def = this.$root.supportDefaults.Impieghi;
                this.$root.sup_apply(null, null, null, def);
            } catch(err){}
        },
        beforeDestroy: function(){
            eventBus.$off("newSupportSide")
        },
        created: function(){
            this.$nextTick(function(){
                var vm = this;
                eventBus.$on("newSupportSide", function(size){
                    vm.$root.supportDefaults.Impieghi = size;
                })
            })
        },
        watch: {
            activeData: function(){
                this.$root.richiestaImpiego = null;
                if(this.activeData != null){
                    this.loadImpieghi();
                }
            },
            "$root.richiestaImpiego": function(){
                if(this.$root.richiestaImpiego != null){
                    this.loadImpieghi(true);
                }
            }
        },
        methods: {
            loadImpieghi: function(fromRoot){
                var vm = this;
                if(this.activeOne == null || this.activeOne.sid != this.activeData.father.sid || fromRoot){
                    this.tree = null;
                    this.children = []
                    if(fromRoot){
                        console.log("***FROM ROOT****", this.$root.richiestaImpiego)
                        this.activeOne = {
                            "sid": this.$root.richiestaImpiego.spi && 
                                    this.$root.richiestaImpiego.spi != "" &&
                                    this.$root.richiestaImpiego.spo ? this.$root.richiestaImpiego.spi : this.$root.richiestaImpiego.cod,
                            "des": this.$root.richiestaImpiego.des,
                        }
                    } else {
                        this.activeOne = this.activeData.father;
                    }
                    this.$root["richiestaImpiegoPerm"] = {cod: this.activeOne.sid};
                    this.loading = true; 
                    this.$root
                        .microservice({
                        role: "catalog",
                        cmd: "GetUsesTree",
                        params: {
                            sid: this.activeOne.sid,
                            labels: ["des"],
                            hideUses: this.$root.preferences.hideUses,
                            root: this.$root.index_as_root
                        }
                    }).then((response) => {
                        var res = response.body;
                        try {
                            res = JSON.parse(response.body);
                        } catch (err) {}
                        if(res=='ENOENT'){
                            eventBus.$emit('alert', {
                                message: vm.$Jed.firstUpperTranslate('index generation in progress, please try later'),
                                type: "warning",
                                action: ''
                            })
                            this.loading = false;
                        }else{
                            this.tree = res.tree
                            if(this.tree){
                                try {
                                    this.tree = this.tree[this.$root.index_as_root]
                                    for(var prop in this.tree.children){
                                        if(prop != "uses"){
                                            this.children.push(this.tree.children[prop]);
                                        } else {
                                            for(var ii = 0; i < this.tree.children.uses.length; i++){
                                                this.children.push(this.tree.children.uses[ii]);
                                            }
                                        }
                                        
                                    }
                                    this.loading = false;
                                    this.scrollToFsable()
                                }catch(err){
                                    var msg = err && err.body && err.body.error ? err.body.error : err
                                    eventBus.$emit('alert', {
                                        message: "Application caught an error <br> <h5>Details: " + "catalog.GetUsesTree - " + msg +'</h5>',
                                        type: "error",
                                        action: ''
                                    })
                                    this.loading = false;
                                }
                            }else{
                                eventBus.$emit('alert', {
                                    message: vm.$Jed.firstUpperTranslate('code %1$s is not in catalog', null, {
                                        key: null,
                                        string: [vm.activeOne.sid]
                                    }),
                                    type: "warning",
                                    action: ''
                                })
                                this.loading = false;
                            }
                        }
                    }, (error) => {
                        this.loading = false;
                        this.scrollToFsable()
                        //vedi gestione errore in main.js > microservice
                    })
                    .catch(err => {
                        console.log(err);
                        var msg = err && err.body && err.body.error ? err.body.error : err
                        eventBus.$emit('alert', {
                            message: "Application caught an error <br> <h5>Details: " + "catalog.GetUsesTree - " + msg +'</h5>',
                            type: "error",
                            action: ''
                        })
                    })
                }
            },
            scrollToFsable: function(){
                this.$nextTick(function(){
                    
                    var fs = document.getElementsByClassName("fsable")
                    try{
                        var nt = Math.max($(".fsable").offset().top - 200, 0);
                        document.getElementById("scroll-uses").scrollTop = nt;
                    } catch(err){
                        console.log(err)
                    }
                })
            }
        }
    }
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/components/menu-sup-components/Impiego.vue?4e2d387a